import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'DEVICES',
    itemActionName: 'DEVICE',
});
